<div class="card" (click)="onCardClick()">
  <ng-container *ngIf="card.loading">
    <ngx-skeleton-loader count="1" [theme]="{ height: '214px' }"></ngx-skeleton-loader>
    <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
  </ng-container>

  <ng-container *ngIf="!card.loading">
    <div class="image" [ngStyle]="{ 'background-image': backgroundImg }"></div>

    <div class="info">
      <div class="name">
        {{ card?.title }}
      </div>
      <div *ngIf="card.typeLabel" class="type">{{ card?.typeLabel }}</div>
    </div>

    <gd-dropdown-menu [positionLeft]="true">
      <a
        *ngFor="let item of dropdownMenuItems"
        class="item"
        [class.delete-item]="item.id === dropdownMenuItemId.delete"
        (click)="onDropdownMenuItemClick(item.id)"
      >
        <img *ngIf="item.icon" [src]="item.icon" alt="" />{{ item.textKey | translate }}
      </a>
    </gd-dropdown-menu>
  </ng-container>
</div>
